import styled, {css} from 'styled-components';
import {FlexRow} from '@forecast-it/design-system';

/*
 * The window's header fields. With $fixedFieldWidths (the QuickBooks window with Invoicing
 * pathways) the fields are, in order: Client, Bill From and Bill To (read only), the tax code and
 * class dropdowns, then the product/service dropdown. Each keeps its own width and the row wraps,
 * so with all six the product/service field moves to a second line instead of every field
 * squeezing its label and value onto two lines. The read-only fields are narrower than the
 * dropdowns; the last field keeps the width of its own dropdown. Every other window keeps its
 * equal-width fields on one line.
 * flex-wrap is set here rather than through FlexRow's `wrap` prop, which styled-components would
 * forward to the DOM as an unknown `wrap` attribute.
 */
export const ExportHeaderRow = styled(FlexRow)<{$fixedFieldWidths?: boolean; $xeroPathways?: boolean}>`
	${({$fixedFieldWidths}) =>
		$fixedFieldWidths &&
		css`
			flex-wrap: wrap;
			row-gap: 24px;

			> * {
				flex: 0 0 auto;
				width: 200px;
			}

			> *:nth-child(-n + 3) {
				width: 170px;
			}

			> *:last-child {
				width: auto;
			}
		`}

	/*
	 * The Xero window with Invoicing pathways: Client, Default tax rate, Bill From and Bill To in four
	 * equal columns, wrapping to two rows of two below 1150px. Four 200px fields and their three gaps
	 * need about 870px, which an 80vw window loses at that width. A media query rather than a
	 * container query: container queries contain layout, which would clip the window's dropdowns.
	 */
	${({$xeroPathways}) =>
		$xeroPathways &&
		css`
			display: grid;
			grid-template-columns: repeat(4, minmax(0, 1fr));

			@media (max-width: 1150px) {
				grid-template-columns: repeat(2, minmax(0, 1fr));
			}
		`}
`;
